import { Container, ContainerProps } from '@material-ui/core'

import { useStyles } from './styles'

export const ContainerPage = ({ children }: ContainerProps) => {
  const classes = useStyles()

  return <Container className={classes.root}>{children}</Container>
}
